import { useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../Providers/AuthProvider'
import { useCart } from '../../Providers/CartProvider'
import { IoCartOutline } from 'react-icons/io5'
import { useTranslation } from 'react-i18next'
import useShowNavBarMenu from '../../Hooks/useShowNavBarMenu'
import SearchBox from '../HomePage/SearchBox'
import { LuPhone } from "react-icons/lu";
import { GoPerson } from "react-icons/go";
import { GoStar } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { ConvertPriceToString } from '../../Helpers/CustomConverter'
import { useCompanyInfo } from '../../Providers/CompanyInfoProvider'
import WholeSalePricesSwitch from '../Components/WholeSalePricesSwitch'
import CustomerInformation from './CustomerInformation'
import ContactSection from '../../Pages/Components/ProductPage/ContactSection'
import AddToBasketModeSwitch from '../Components/AddToBasketModeSwitch'
import { useOffers } from '../../Providers/OffersProvider'
import { IoIosArrowRoundBack } from "react-icons/io";
import { FaListUl } from "react-icons/fa";
import { FaMoneyBill1Wave } from "react-icons/fa6";
import { MdPeople } from "react-icons/md";
import { IoCartSharp } from "react-icons/io5";
import { FiLogOut } from "react-icons/fi";
import useCheckLicense from '../../Hooks/useCheckLicense.ts'
import { Licenses } from '../../Data/Licenses.ts'
import useCommonFunctions from '../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions.jsx'
import { AccountCurrentView } from '../../Data/PageModeEnums.ts'
import { useShop } from '../../Providers/ShopProvider.jsx'
import { FiShoppingCart } from "react-icons/fi";
import { useSavedBaskets } from '../../Providers/SavedBasketsProvider.jsx'

import 'react-loading-skeleton/dist/skeleton.css'
import './Styles/NavBar.css'

const NavBar = () => {
    const navigate = useNavigate()
    const contactSectionTimeoutRef = useRef(null)

    const { authState, logout, wholesalePrices } = useAuth()
    const { cartItems, basketTotalPriceNet } = useCart()
    const { userMenuRef, showUserMenu, setShowUserMenu } = useShowNavBarMenu()
    const { t } = useTranslation()
    const [showContactSection, setShowContactSection] = useState(false)
    const { savedOfferId, selectedSavedOffer } = useOffers()
    const { selectedSavedBasket } = useSavedBaskets()
    const { checkLicense } = useCheckLicense()
    const { loadingData, navBarItems, companyInfoData } = useCompanyInfo()
    const { getLoadingDataSkeleton, getSocialMediaIcons, generateUserInformation, NotificationSection, QuickContractorSelectorSection } = useCommonFunctions()
    const { clearProductsFilter } = useShop()

    useEffect(() => {
        return () => {
            cancelHideTimeout()
        }
    }, [])


    const handleReDirect = (link, direct) => {
        if (link == '/shop') {
            clearProductsFilter()
        }
        if (direct) {
            navigate(link)
        }
        else {
            window.open(link, '_blank')
        }
    }

    const handleReDirectForAccount = (e) => {
        if (!authState.user) {
            navigate('/login')
        }
        else {
            if (showUserMenu) {
                setShowUserMenu(false)
            } else {
                setShowUserMenu(true)
            }

        }
    }

    const generateNavBarItems = () => {
        return navBarItems.map((i, index) => (
            <div key={index} className="col d-flex justify-content-center align-items-center">
                <span className={`element-pointer ${index === 0 ? 'ms-5' : ''}`} onClick={() => handleReDirect(i.reDirectLink, i.isReDirectLinkDirectToEHandel)}>{i.name}</span>
            </div>
        ))
    }

    const handleLogoClick = () => {
        handleReDirect('/', true)
    }

    const cancelHideTimeout = () => {
        if (contactSectionTimeoutRef.current) {
            clearTimeout(contactSectionTimeoutRef.current)
        }
    }

    const handleContactSectionMouseEnter = () => {
        cancelHideTimeout()
        setShowContactSection(true)
    }

    const handleContactSectionMouseLeave = () => {
        contactSectionTimeoutRef.current = setTimeout(() => {
            setShowContactSection(false)
        }, 300)
    }

    const basketVisibility = authState.custId ? '' : 'hidden'
    const favoriteVisibility = authState.user ? '' : 'hidden'
    const safeStr = companyInfoData.topBarLogoSourceWhiteMode || ''; // default to empty string
    const logoPath = companyInfoData ? safeStr.replace('../', '') : '';

    return (
        <>
            <div className="container-fluid">
                <div className="fixed-top">
                    <div className='d-flex flex-column'>
                        <div className="row" style={{ backgroundColor: 'white' }}>
                            <CustomerInformation />
                        </div>
                        <div className='navbar'>
                            <div className="col-auto d-flex element-pointer align-items-center ms-5 me-5" onClick={() => handleLogoClick()}>
                                <img src={`${process.env.PUBLIC_URL}/${logoPath}`} alt='logo' height={68} style={{ padding: '5px' }} />
                            </div>
                            <div className="col me-5">
                                <SearchBox />
                            </div>
                            <div className="col-1 d-flex justify-content-center align-items-center element-pointer" onMouseEnter={handleContactSectionMouseEnter}
                                onMouseLeave={handleContactSectionMouseLeave}>
                                <div style={{ position: 'relative' }}>
                                    <LuPhone size={25} className='nav-bar-color-primary me-3' />
                                    <span>Kontakt</span>
                                </div>
                                {showContactSection && <div className='nav-bar-contact-section'>
                                    <ContactSection />
                                </div>}
                            </div>

                            <div className="co-2 d-flex justify-content-center align-items-center">
                                <div className='element-pointer' style={{ position: 'relative' }} onClick={handleReDirectForAccount}>
                                    <div className="d-flex align-items-center">
                                        <GoPerson size={25} className='nav-bar-color-primary me-3' />
                                        {generateUserInformation(false)}
                                    </div>
                                    {checkLicense([Licenses.TgInstalacje]) ? (<UserMenu
                                        t={t}
                                        showUserMenu={showUserMenu}
                                        setShowUserMenu={setShowUserMenu}
                                        logout={logout}
                                        authState={authState}
                                        userMenuRef={userMenuRef}
                                    />) : (<UserMenuFerrodo
                                        t={t}
                                        showUserMenu={showUserMenu}
                                        setShowUserMenu={setShowUserMenu}
                                        logout={logout}
                                        authState={authState}
                                        userMenuRef={userMenuRef}
                                    />)}

                                </div>
                            </div>
                            <div className={`${favoriteVisibility} col-auto d-flex justify-content-end align-items-center element-pointer me-2 ms-4`}>
                                <GoStar size={25} className='nav-bar-color-primary' onClick={() => handleReDirect('/SavedBaskets', true)} />
                            </div>
                            <BasketSection
                                basketVisibility={basketVisibility}
                                handleReDirect={handleReDirect}
                                cartItems={cartItems}
                                wholesalePrices={wholesalePrices}
                                basketTotalPriceNet={basketTotalPriceNet}
                                savedOfferId={savedOfferId}
                                selectedSavedOffer={selectedSavedOffer}
                                selectedSavedBasket={selectedSavedBasket}
                            />
                            <div className={`${basketVisibility} col-auto d-flex justify-content-start align-items-center ms-2 me-3`}>
                                <NotificationSection
                                    isMobile={false}
                                />
                            </div>
                            <div className='col-auto d-flex align-items-start me-5'>
                                <QuickContractorSelectorSection
                                    isMobile={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {loadingData ? (
                    <div className='navbar-bottom row'>
                        <div className='navbar-bottom-loading'>
                            {getLoadingDataSkeleton(false)}
                        </div>
                    </div>
                ) :
                    (
                        <div className="navbar-bottom row">
                            {generateNavBarItems()}
                            {savedOfferId != -1 ? (<AddToBasketModeSwitch />) : (<WholeSalePricesSwitch isMobileView={false} />)}
                            <div className="col-1 d-flex justify-content-around align-items-center me-5">
                                {getSocialMediaIcons(handleReDirect, false)}
                            </div>
                        </div>
                    )}
            </div>
        </>
    )
}

const BasketSection = ({ basketVisibility, handleReDirect, cartItems, wholesalePrices, basketTotalPriceNet, savedOfferId, selectedSavedOffer, selectedSavedBasket }) => {
    const showBasketSummaryStyle = wholesalePrices ? '' : 'hidden'
    const { handleBackToOfferClick, handleBackToSavedBasket } = useCommonFunctions()

    let selectedSavedOfferItemsCount = selectedSavedOffer && selectedSavedOffer.basketItems ? selectedSavedOffer.basketItems.length : 0
    if (savedOfferId != -1) {
        return (
            <div className='col-auto d-flex flex-column align-items-center justify-content-center element-pointer cart-holder'
                onClick={() => handleBackToOfferClick(selectedSavedOffer.savedOffer.mode)}>
                <span className='ms-3 me-3'>Powrót</span>
                <div className="row mt-3">
                    <div className="col-5 position-relative">
                        <FiShoppingCart size={20} color='var(--primary)' />
                        <div className='notification-circle-for-offer-navbar'>
                            {selectedSavedOfferItemsCount}
                        </div>
                    </div>
                    <div className="col position-relative">
                        <IoIosArrowRoundBack size={30} color='var(--primary)' />
                    </div>
                </div>
            </div>
        )
    }
    else if (selectedSavedBasket) {
        return <div className='col-auto d-flex flex-column align-items-center justify-content-center element-pointer cart-holder'
            onClick={() => handleBackToSavedBasket()}>
            <span className='ms-3 me-3'>Powrót</span>
            <div className="row mt-3">
                <div className="col-5 position-relative">
                    <FiShoppingCart size={20} color='var(--primary)' />
                    <div className='notification-circle-for-offer-navbar'>
                        {selectedSavedBasket.basketItems.length}
                    </div>
                </div>
                <div className="col position-relative">
                    <IoIosArrowRoundBack size={30} color='var(--primary)' />
                </div>
            </div>
        </div>
    }
    else {
        return (<div className={`col-auto d-flex justify-content-between align-items-center element-pointer cart-holder ${basketVisibility}`} onClick={() => handleReDirect('/Cart', true)}>
            <div className='ms-3 me-3' style={{ position: 'relative' }}>
                <IoCartOutline size={25} alt="Koszyk" className='nav-bar-color-primary' />
                {cartItems.basketItems && cartItems.basketItems.length > 0 && (
                    <div className='notification-circle-navbar'>
                        {cartItems.basketItems.length}
                    </div>
                )}
            </div>
            <div className="d-flex flex-column me-2">
                <span className='ms-auto'>Koszyk</span>
                {cartItems && cartItems.basketItems && cartItems.basketItems.length > 0 ?
                    (<span className={showBasketSummaryStyle}>{ConvertPriceToString(basketTotalPriceNet)}</span>) :
                    (<span className={showBasketSummaryStyle}>{ConvertPriceToString(0)}</span>)
                }
            </div>
        </div>)
    }
}

const UserMenuFerrodo = ({ t, showUserMenu, setShowUserMenu, logout, authState, userMenuRef }) => {   //POPRZEDNI Z IKONAMY ALE NIE ZGODNY Z PROJEKTEM TG
    if (showUserMenu) {
        return (
            <div className='user-context-menu' ref={userMenuRef}>
                <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.Zamowienia} className='link'>
                        <FaListUl size={26} style={{ marginRight: 10 }} />
                        {t('orders_navigation')}
                    </Link>
                </div>
                <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.Finanse} className='link'>
                        <FaMoneyBill1Wave size={26} style={{ marginRight: 10 }} />
                        {t('invoices_navigation')}
                    </Link>
                </div>
                {authState.user.isOperator && (
                    <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                        <Link to={AccountCurrentView.Kontrahenci} className='link'>
                            <MdPeople size={26} style={{ marginRight: 10 }} />
                            {t('customers_navigation')}
                        </Link>
                    </div>
                )}
                <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.ZapisaneKoszyki} className='link'>
                        <IoCartSharp size={26} style={{ marginRight: 10 }} />
                        Szybkokoszyki
                    </Link>
                </div>
                {!authState.user.isOperator || (authState.user.isOperator && authState.selectedCustomer !== null) ? (
                    <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                        <Link to={AccountCurrentView.MojeKonto} className='link'>
                            <span className='ms-5'>{authState.user.isOperator ? t('my_account_navigation_PH') : t('my_account_navigation')}</span>
                        </Link>
                    </div>
                ) : <></>}
                <div className='user-context-menu-option link' onClick={() => { setShowUserMenu(false); logout(); }} >
                    <FiLogOut size={26} style={{ marginRight: 10 }} />
                    {t('logout_navigation')}
                </div>
            </div>
        )
    }
}

const UserMenu = ({ t, showUserMenu, setShowUserMenu, logout, authState, userMenuRef }) => {
    if (showUserMenu) {
        return (
            <div className='user-context-menu' ref={userMenuRef}>
                {!authState.user.isOperator || (authState.user.isOperator && authState.selectedCustomer !== null) ? (
                    <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                        <Link to={AccountCurrentView.MojeKonto} className='link'>
                            <span className='ms-5'>{authState.user.isOperator ? t('my_account_navigation_PH') : t('my_account_navigation')}</span>
                        </Link>
                    </div>
                ) : <></>}
                <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.Finanse} className='link'>
                        <span className='ms-5'>{t('invoices_navigation')}</span>
                    </Link>
                </div>
                <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.Zamowienia} className='link'>
                        <span className='ms-5'>{t('orders_navigation')}</span>
                    </Link>
                </div>
                <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.Oferty} className='link'>
                        <span className='ms-5'>{t('offers_navigation')}</span>
                    </Link>
                </div>
                {authState.user.isOperator && (
                    <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                        <Link to={AccountCurrentView.Kontrahenci} className='link'>
                            <span className='ms-5'>{t('customers_navigation')}</span>
                        </Link>
                    </div>
                )}
                <div className='user-context-menu-option' onClick={() => setShowUserMenu(false)}>
                    <Link to={AccountCurrentView.ZapisaneKoszyki} className='link'>
                        <span className='ms-5'>Szybkokoszyki</span>
                    </Link>
                </div>
                <div className='log-out-button mt-2 ms-4 me-4 mb-3' onClick={() => { setShowUserMenu(false); logout(); }} >
                    <span className=''>{t('logout_navigation')}</span>
                </div>
            </div>
        )
    }
}

export default NavBar